export default __webpack_public_path__ + "static/Coffee-8afe9d4bfbb9886c526bc7111b5ee81e.svg";